import {
  FormControl,
  InputLabel,
  MenuItem,
  Typography,
  Modal,
  Box,
  Select,
  Stack,
  Button,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { zoneFieldDisable } from "../../../../../../common/utils/ReportsFilters";
import { TerritoryDataStore } from "../../../../../../store/main/TerritoryDataStore";
import { useEffect } from "react";
import { CustomerDatabaseStore } from "../../../../../../store/main/CustomerDatabaseStore";
import { CustomerDetails } from "../../../../../../domain/models/customer-database/customer-details";
import { MobileModalStyle } from "../../../../../../common/constants/custom-style";
import Swal from "sweetalert2";

type Props = {
  open: boolean;
  handleClose: Function;
  row: CustomerDetails;
};

type FormFields = {
  department: string;
  team: string;
  brick: string;
};

const AddBrickModalMobile: React.FC<Props> = ({ open, handleClose, row }) => {
  const {
    teamData,
    fetchTeam,
    departmentData,
    fetchDepartment,
    fetchBricksMaster,
    bricksMasterData,
  } = TerritoryDataStore();
  const { fetchCustomerData, filterStore, fetchCustomerSummaryCount } =
    CustomerDatabaseStore();
  useEffect(() => {
    fetchTeam();
    fetchDepartment();
    fetchBricksMaster([row.mappings.headquarter_id]);
  }, []);

  const { handleSubmit, control, watch } = useForm<FormFields>({
    mode: "onChange",
  });

  const { userRole, updateCustomerMapping } = CustomerDatabaseStore();

  const onSubmit = () => {
    const transferPayload = {
      customer_sub_name: row.customer_type.sub_name,
      customer_id: row.id,
      brick_id: watch("brick"),
      headquarter_id: row.mappings.headquarter_id,
      headquarter_code: row.mappings.headquarter_code,
      department_code: watch("department"),
      old_headquarter_code: row.mappings.headquarter_code,
      mapping_id: row.mapping_id,
      team_id: watch("team"),
      reason: "Brick Mapped",
    };

    const update = updateCustomerMapping(transferPayload, 1, false);
    if (update) {
      Swal.fire({
        icon: "success",
        timer: 3000,
        text: "Mapping Successful",
        customClass: {
          container: "swal2-style",
        },
        confirmButtonColor: "#3085d6",
      });
    } else {
      Swal.fire({
        icon: "error",
        timer: 3000,
        text: "Mapping Failed",
        customClass: {
          container: "swal2-style",
        },
        confirmButtonColor: "#3085d6",
      });
    }
    fetchCustomerSummaryCount(filterStore);
    fetchCustomerData();
    handleClose();
  };
  return (
    <>
      <Modal open={open} onClose={() => handleClose()}>
        <Box sx={MobileModalStyle}>
          <Typography
            textAlign="center"
            variant="h6"
            fontFamily="Segoe UI"
            fontWeight={600}
            color="#4D4D4D"
            marginBottom={3}
          >
            Brick Mapping
          </Typography>
          <Stack spacing={2}>
            <Controller
              name="department"
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <FormControl size="small">
                  <InputLabel>Department</InputLabel>
                  <Select
                    value={value}
                    size="small"
                    onChange={onChange}
                    label="Department"
                  >
                    {departmentData?.map((name) => (
                      <MenuItem value={name.code}>{name.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
            <Controller
              name="team"
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <FormControl size="small">
                  <InputLabel>Team</InputLabel>
                  <Select
                    disabled={zoneFieldDisable(userRole.role)}
                    value={value}
                    size="small"
                    label="Team"
                    onChange={onChange}
                  >
                    {teamData?.map((name) => (
                      <MenuItem value={name.id.toString()}>
                        {name.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
            <Controller
              name="brick"
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <FormControl size="small">
                  <InputLabel>Brick</InputLabel>
                  <Select
                    disabled={zoneFieldDisable(userRole.role)}
                    value={value}
                    size="small"
                    label="Brick"
                    onChange={onChange}
                  >
                    {bricksMasterData?.map((name) => (
                      <MenuItem value={name.id.toString()}>
                        {name.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          </Stack>
          <Stack direction={"row"} p={2} spacing={2} justifyContent={"center"}>
            <Button
              disabled={
                !(watch("brick") && watch("department") && watch("team"))
              }
              color="primary"
              variant="contained"
              onClick={handleSubmit(onSubmit)}
            >
              Map Brick
            </Button>
            <Button color="error" onClick={() => handleClose()}>
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default AddBrickModalMobile;
